import { Controller, useFormContext } from 'react-hook-form';

import { Box, useTheme } from '@mui/material';
import { EmailEditorProps } from 'features/References';
import { ErrorText } from '../../../../Connect/features/ConnectATSIntegration/CandidateFeedback/Scorecard/Create/components/ScorecardQuestionAndAnswerSection';
import { Input } from 'sharedComponents/Input';
import { TextEditor } from 'sharedComponents/TextEditor/TextEditor';

export const EmailEditor: React.FC<EmailEditorProps> = ({ dataTestId }) => {
  const theme = useTheme();
  const { control } = useFormContext();

  return (
    <>
      <Controller
        name="subject"
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          const handleChange = (newValue: string) => {
            onChange(newValue);
          };

          return (
            <Box>
              <Input
                hasError={Boolean(error)}
                placeholder="Email subject"
                value={value || ''}
                onChange={handleChange}
                sx={{
                  height: theme.spacing(5.25),
                  '& .MuiInputBase-root': { height: theme.spacing(5.25) },
                }}
              />
              {Boolean(error) && <ErrorText dataTestId={`${dataTestId}-required-error`} />}
            </Box>
          );
        }}
      />
      <Controller
        name="message"
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          const handleChange = (newValue: string) => {
            onChange(newValue);
          };

          return (
            <Box>
              <TextEditor value={value || ''} onChange={handleChange} />
              {Boolean(error) && <ErrorText dataTestId={`${dataTestId}-required-error`} />}
            </Box>
          );
        }}
      />
    </>
  );
};
